module.exports = __webpack_public_path__ + "img/home_two_table_center.bc262850.png";